import { name } from '../../symbols'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { SiteMembersWixCodeSdkHandlersEditor } from '../../types'
import { SdkHandlersProvider, LoggerSymbol, ILogger } from '@wix/thunderbolt-symbols'
import { INTERACTIONS, ISiteMembersApi, SiteMembersApiSymbol } from 'feature-site-members'

const notAllowedMessage = (methodName: string) => {
	const msg = `${methodName}() cannot be used in preview mode. It works in published sites only.`
	console.warn(msg)
}

export const dsSiteMembersWixCodeSdkHandlers = withDependencies(
	[SiteMembersApiSymbol, LoggerSymbol],
	(
		{ getMemberDetails }: ISiteMembersApi,
		logger: ILogger
	): SdkHandlersProvider<SiteMembersWixCodeSdkHandlersEditor> => ({
		getSdkHandlers: () => ({
			[name]: {
				getMemberDetails,
				async login() {
					logger.interactionStarted(INTERACTIONS.EDITOR.CODE_LOGIN)
					logger.interactionEnded(INTERACTIONS.EDITOR.CODE_LOGIN)
					notAllowedMessage('login')
				},
				async applySessionToken() {
					notAllowedMessage('applySessionToken')
				},
				async promptForgotPassword() {
					notAllowedMessage('promptForgotPassword')
				},
				async promptLogin() {
					notAllowedMessage('promptLogin')
				},
				async register() {
					notAllowedMessage('register')
				},
				async handleOauthToken() {
					notAllowedMessage('handleOauthToken')
				},
				registerToUserLogin() {
					notAllowedMessage('registerToUserLogin')
				},
				registerToMemberLogout() {
					notAllowedMessage('registerToMemberLogout')
				},
				logout() {
					notAllowedMessage('logout')
				},
				async sendSetPasswordEmail() {
					notAllowedMessage('sendSetPasswordEmail')
				},
			},
		}),
	})
)
